import script from "./AlertDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AlertDialog.vue?vue&type=script&lang=ts&setup=true"

import "./AlertDialog.vue?vue&type=style&index=0&id=1fbb6978&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fbb6978"]])

export default __exports__